__turbopack_context__.v({
  "container-desktop": "SimulationSideCard-module-scss-module__P7nk1a__container-desktop",
  "drawer-button": "SimulationSideCard-module-scss-module__P7nk1a__drawer-button",
  "electricity": "SimulationSideCard-module-scss-module__P7nk1a__electricity",
  "gas": "SimulationSideCard-module-scss-module__P7nk1a__gas",
  "producer-header": "SimulationSideCard-module-scss-module__P7nk1a__producer-header",
  "producer-img": "SimulationSideCard-module-scss-module__P7nk1a__producer-img",
  "producer-info": "SimulationSideCard-module-scss-module__P7nk1a__producer-info",
  "producer-mobile-wrapper": "SimulationSideCard-module-scss-module__P7nk1a__producer-mobile-wrapper",
  "producer-name-wrapper": "SimulationSideCard-module-scss-module__P7nk1a__producer-name-wrapper",
  "product": "SimulationSideCard-module-scss-module__P7nk1a__product",
  "promo": "SimulationSideCard-module-scss-module__P7nk1a__promo",
  "promo-line": "SimulationSideCard-module-scss-module__P7nk1a__promo-line",
  "slider-container": "SimulationSideCard-module-scss-module__P7nk1a__slider-container",
});
